var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({attrs:{"items":_vm.items,"item-text":"label","item-value":"deviceId","loading":_vm.loading,"label":_vm.label,"prepend-icon":"$freshvue-video-input"}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }